<a class="item" [routerLink]="[news.contentId]" routerLinkActive="router-link-active"
        [class.item--read]="news.status === NewsStatus.Read">
    <img [src]="news.thumbnail" alt="News thumbnail" class="item__thumbnail">
    <div class="item__column">
        <div class="item__heading" [innerHTML]="news.heading"></div>
        <div class="item__text" [innerHTML]="news.publishedDate | haDate:'date'"></div>
    </div>
    <div class="item__click"></div>
</a>
